export enum Weekdays {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

export const weekdays: Weekdays[] = [
  Weekdays.SUNDAY,
  Weekdays.MONDAY,
  Weekdays.TUESDAY,
  Weekdays.WEDNESDAY,
  Weekdays.THURSDAY,
  Weekdays.FRIDAY,
  Weekdays.SATURDAY,
]
